import { ProbabilitiesTable } from "../Inspect/ProbabilitiesTable";
import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";

function Sample1110000() {
  const llmPredictions = {
    " potent": 0.4870845377445221,
    " effective": 0.3430943191051483,
    " powerful": 0.013714337721467018,
    "-": 0.011076223105192184,
    " effic": 0.00870541762560606,
    " or": 0.008263254538178444,
    " dangerous": 0.0060253264382481575,
    " than": 0.005908000282943249,
    " active": 0.004096153192222118,
    " of": 0.004068512935191393,
    " common": 0.004015388432890177,
    " reliable": 0.003126797266304493,
    " commonly": 0.003084666794165969,
    " successful": 0.0024096996057778597,
    " likely": 0.00240464904345572,
    " useful": 0.0021442249417304993,
    " desirable": 0.002076801611110568,
    " important": 0.0019362240564078093,
    " selective": 0.001847643288783729,
    " promising": 0.0018112423131242394,
  };
  const saePredictions = {
    " effective": 0.4633447229862213,
    " potent": 0.24536697566509247,
    " than": 0.02090812660753727,
    " effic": 0.01778373122215271,
    " likely": 0.012905089184641838,
    "-": 0.009717630222439766,
    " toxic": 0.009069595485925674,
    " selective": 0.008368137292563915,
    " or": 0.0075846039690077305,
    " powerful": 0.0073419841937720776,
    " commonly": 0.007061465177685022,
    " frequently": 0.00631942180916667,
    " often": 0.00574545469135046,
    " expensive": 0.005537939257919788,
    " successful": 0.005400977563112974,
    " common": 0.005012739449739456,
    " dangerous": 0.004519968759268522,
    " active": 0.004193558357656002,
    " lethal": 0.003889996325597167,
    " of": 0.0036181758623570204,
  };

  return (
    <section className="sample">
      <h4>
        <SampleAnchor modelId="mini" sampleId="1110000" />
        <span> - </span>
        <SampleQuote
          text="tenofovir are either seen as less potent"
          targetIdx={28}
          targetLength={5}
        />
      </h4>
      <p>
        This circuit predicts that the next token will be an adjective describing the effectiveness
        of medication. Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="1110000" featureKey="0.8.812" compact /> responds to
        words like “very” or “extremely”, constraining the next word in a sequence to adjectives.
        Feature <FeatureAnchor modelId="mini" sampleId="1110000" featureKey="0.8.2499" compact />{" "}
        responds to phrases assessing the risks of various chemicals, further narrowing the list of
        possible next tokens to those describing efficacy.
      </p>
      <div className="figures">
        <figure>
          <figcaption>LLM Prediction</figcaption>
          <ProbabilitiesTable probabilities={llmPredictions} limit={3} />
          <p className="description">
            Most likely tokens representing adjectives that describe the effectiveness of medication
          </p>
        </figure>
        <figure>
          <figcaption>Reconstructed Prediction</figcaption>
          <ProbabilitiesTable probabilities={saePredictions} limit={3} />
          <p className="description">
            Most likely tokens after using SAE features in the last layer to reconstruct the
            residual stream
          </p>
        </figure>
      </div>
    </section>
  );
}

export { Sample1110000 };
